import React, { FC, ReactNode } from 'react';
import { Button, type ButtonProps, CircularProgress } from '@mui/material';

interface LoadingButtonProps extends ButtonProps {
  isLoading?: boolean;
  loadingIndicator?: ReactNode;
  children: ReactNode;
  disabled?: boolean;
}

const LoadingButton: FC<LoadingButtonProps> = ({
  isLoading = false,
  loadingIndicator = <CircularProgress size={24} />,
  children,
  disabled,
  ...props
}) => (
  <Button {...props} disabled={disabled || isLoading}>
    {!isLoading ? children : loadingIndicator}
  </Button>
);

export default LoadingButton;
